import { render, staticRenderFns } from "./Action_trans_qywxx.vue?vue&type=template&id=1495d78d&scoped=true"
import script from "./Action_trans_qywxx.vue?vue&type=script&lang=js"
export * from "./Action_trans_qywxx.vue?vue&type=script&lang=js"
import style0 from "./Action_trans_qywxx.vue?vue&type=style&index=0&id=1495d78d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495d78d",
  null
  
)

export default component.exports